import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { size, breakpoints } from "@argo/principles";
import { Link } from "@argo/ui-elements";
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
var SocialBase = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n  ", "\n\n  @media (min-width: ", "px) {\n    width: 60%;\n  }\n\n  @media (min-width: 1200px) {\n    width: 30%;\n    margin: 0;\n  }\n\n  > a {\n    height: 48px;\n    padding: 12px;\n  }\n\n  > a:hover {\n      cursor: pointer;\n  }\n\n  span {\n    margin: 0 ", "px 0 0;\n  }\n\n  > a:last-child > svg {\n    width: 60px;\n  }\n"])), function (props) {
  return props.enableOneTrust ? '' : "margin: 0 0 ".concat(size.md, "px 0;");
}, breakpoints.md, size.micro);
var Social = function Social(_ref) {
  var links = _ref.links,
    enableOneTrust = _ref.enableOneTrust;
  return React.createElement(SocialBase, {
    enableOneTrust: enableOneTrust
  }, links && links.map(function (link, i) {
    return React.createElement(Link, {
      key: i,
      href: "".concat(GLOBALNAV_KBB_BASE_URL).concat(link.url),
      "data-partner": link.dataPartner,
      "data-automation": link.omnitureTag,
      "data-tag-id": "socialLinks".concat(i),
      alt: link.altText,
      target: "_blank",
      rel: "noopener",
      "aria-label": link.ariaLabel
    }, link.icon);
  }));
};
Social.displayName = 'Social';
Social.propTypes = {
  links: PropTypes.array
};
export default Social;